log.info({action: 'load_cylerian_platform', message: 'LOADING CYLERIAN PLATFORM'});
